import React from 'react';
import classNames from 'classnames/bind';
import Text from '../../../../../atoms/Text';
import { EVENT_HEADER_CONTENT } from '../../../Constants';
import styles from './index.module.pcss';
import { replaceWithJioCDN } from '../../../../../../utils/imageHandling';

interface DesktopMainHeaderProps {
  topShopperHeader: string;
  topShopperSubHeader: string;
}

const cx = classNames.bind(styles);
const { image } = EVENT_HEADER_CONTENT;
function DesktopMainHeader({
  topShopperHeader,
  topShopperSubHeader
}: DesktopMainHeaderProps): JSX.Element {
  return (
    <div className={cx('desk-tpsps-header-wrapper')}>
      <div className={cx('desk-tpsps-header')}>
        <div className={cx('desk-tpsps-header-image')}>
          <img alt="Balloon image" src={replaceWithJioCDN(image)} />
        </div>
        <div className={cx('desk-tpsps-header-content')}>
          <Text weight="bold" variant="T6" color="White">
            {topShopperHeader}
          </Text>
          <Text weight="bold" variant="T8" color="White">
            {topShopperSubHeader}
          </Text>
        </div>
      </div>
    </div>
  );
}

DesktopMainHeader.defaultProps = {
  className: ''
};

export default DesktopMainHeader;
